import { useEffect, useState, useContext } from "react";
// esri
import Point from "@arcgis/core/geometry/Point";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

interface IProps {
  mapView: any;
  coordinates: number[];
  text: string;
}

const TextSymbol = ({ mapView, coordinates, text }: IProps) => {
  const activePanel = useSelector((state: any) => state.app.activePanel);

  const [offset, setOffset] = useState({ y: 0, left: 0 });

  const mapPoint = new Point({
    x: coordinates[0],
    y: coordinates[1],
    spatialReference: mapView.spatialReference,
  });
  const screenPoint = mapView.toScreen(mapPoint);

  useEffect(() => {
    let element = document.getElementsByClassName("esri-view-root");
    const rect = element[0].getBoundingClientRect();
    setOffset({ y: rect.y, left: rect.left });
  }, [activePanel]);
  return (
    <div
      style={{
        zIndex: "999",
        backgroundColor: "black",
        position: "fixed",
        left: `${screenPoint.x + offset.left}px`,
        top: `${screenPoint.y + offset.y / 2}px`,
        minWidth: "43px",
        width: "auto",
        height: "16px",
        transform: "translate(-50%, -50%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <span
        style={{
          color: "#fff",
          fontSize: 9,
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {`${text} mi`}
      </span>
    </div>
  );
};
export default TextSymbol;
